
import 'vuetify/src/styles/components/_selection-controls.sass'
import Selectable from 'vuetify/lib/mixins/selectable'
import { Sizeable } from '@/mixins'
import KIcon from '../../Icon/KIcon'

/**
 * Note: This file is a copy of VCheckbox. We are not extending it so that it's less coupled to Vuetify's.
 *
 * The main thing we are doing in this file is rendering a div and a k-icon for the box and check instead of just
 * one SVG file for on / off.
 */
export default {
  name: 'KFieldCheckboxBase',

  mixins: [
    Selectable,
    Sizeable
  ],

  props: {
    indeterminate: Boolean,
    indeterminateIcon: {
      type: String,
      default: '$vuetify.icons.checkboxIndeterminate'
    },
    onIcon: {
      type: String,
      default: '$vuetify.icons.checkboxOn'
    },
    offIcon: {
      type: String,
      default: '$vuetify.icons.checkboxOff'
    }
  },

  data: vm => ({
    inputIndeterminate: vm.indeterminate
  }),

  computed: {
    classes () {
      return {
        'v-input--selection-controls': true,
        'v-input--checkbox': true
      }
    },
    computedIcon () {
      if (this.inputIndeterminate) {
        return this.indeterminateIcon
      } else if (this.isActive) {
        return this.onIcon
      } else {
        return this.offIcon
      }
    }
  },

  watch: {
    indeterminate (val) {
      this.inputIndeterminate = val
    }
  },

  methods: {
    genCheckbox () {
      return this.$createElement('div', {
        staticClass: 'v-input--selection-controls__input'
      }, [
        this.genInput('checkbox', {
          ...this.$attrs,
          'aria-checked': this.inputIndeterminate
            ? 'mixed'
            : this.isActive.toString()
        }),
        this.$createElement('div', {
          class: {
            'k-field-checkbox__input': true,
            'k-field-checkbox__input--checked': this.isActive,
            'k-field-checkbox--large': this.large,

          },
        }, [
          this.$createElement(KIcon, {
            props: {
              color: 'brand-pink',
              size: 9,
            },
          }, [
            'check'
          ])
        ])
      ])
    },
    genDefaultSlot () {
      return [
        this.genCheckbox(),
        this.genLabel()
      ]
    }
  }
}
